<template>
  <div class="content_main">
    <p class="content_normal">We are solicitors to the Flypay loan application. The report from the
      law enforcement agency as of today suggested that your BVN should be blacklisted today. Also,
      following our previous letter, Our in-house representatives tried to check your business unit
      and home address but have not been able to locate your original address despite having tracked
      it In the last 48 hours. Ultimately, there are doubts concerning the details you sent in the
      course of receiving this loan. It is now paramount that our legal team take up the affairs of
      your loan at any moment. The charges against you will not change as we have taken the first
      step to blacklist your BVN, the following actions will follow:</p>
    <br />
    <p class="content_normal">1. A lien will be placed on your bank account</p>
    <p class="content_normal">2. We will file for a total ban on your profile from the credit bureau
      so that other loan companies can be aware of your attitude.</p>
    <p class="content_normal">3. Our legal department will summon you to court.</p>
    <br />
    <p class="content_normal">Note: It is not our practice to exhibit actions such as this but our
      company cannot afford to incur a further loss that will ruin the company completely. Kindly
      give the necessary cooperation in order to be able to help you. </p>
    <br />
    <p class="content_normal">If you are experiencing difficulty to repay, our company can waive the
      late payment fee of 40% and lets you repay the outstanding. Kindly respond to our recovery
      officers or contact: </p>
    <br />
    <p class="content_normal">WhatsApp-09120482700</p>
    <p class="content_normal">Email- collection@flypay.n</p>
    <br />
    <p class="content_normal">This letter requires you to give an immediate response.</p>
    <br />
    <p class="content_normal">While waiting for your prompt reply, do have the assurance of our best
      wishes.</p>
    <br />
    <p class="content_normal">Best regards</p>
  </div>
</template>

<script>
export default {
  name: 'flypayM4',
};
</script>


<style lang="stylus" scoped>
px = (1 / 24.75vw);
.content {
  padding: 25 *px 16 *px;

  .content_main {
    line-height: 20px;
    text-indent: 16px;
    margin-top: 16px;
  }

  .content_normal {
    text-align: left;
    text-indent: 16px;
  }
}
</style>
